<section class="inner-page">
    <div class="container tofupadding">
        <div class="d-none d-md-block">
            <h2 class="set-text"><b>{{item.pushTitle}}</b></h2>
            <h4 class="set-text">{{item?.detail1}}</h4>
            <h4 class="set-text">{{item?.detail2}}</h4>
            <h4 class="set-text">{{item?.detail3}}</h4>

            <h2 class="set-text"><b>วันที่แจ้งเตือน</b></h2>
            <h4 class="set-text">{{item.notifyDateTime | thaidate : 'fulldatetimeclock'}}</h4><br>
            <h2 class="set-text"><b>รายละเอียด</b></h2>
            <!-- <textarea *ngIf="item.detail1==null" class="form-control-plaintext" [(ngModel)]="item.title"  readonly  style="resize: none;" autosize></textarea> -->
            <textarea class="form-control-plaintext" [(ngModel)]="item.fullDetail"  readonly style="resize: none;" autosize></textarea>
            

        </div>
        <div class="d-md-none">
            <h2 class="set-text"><b>{{item.pushTitle}}</b></h2>
            <h4 class="set-text">{{item?.detail1}}</h4>
            <h4 class="set-text">{{item?.detail2}}</h4>
            <h4 class="set-text">{{item?.detail3}}</h4>

            <h2 class="set-text"><b>วันที่แจ้งเตือน</b></h2>
            <p class="set-text">{{item.notifyDateTime | thaidate : 'fulldatetimeclock'}}</p><br> 
            <h2 class="set-text"><b>รายละเอียด</b></h2> 
            <textarea class="form-control-plaintext" [(ngModel)]="item.fullDetail"  readonly style="resize: none;" autosize></textarea>

            <!-- <textarea *ngIf="item.detail1==null" class="form-control-plaintext" [(ngModel)]="item.title"  readonly
            style="resize: none;" autosize></textarea>
            <textarea class="form-control-plaintext" [(ngModel)]="item.detail1"  readonly style="resize: none;" autosize></textarea>
            <p class="set-text">{{item?.detail2}}</p> <p class="set-text" style="color: #ff0d0d !important;">{{item?.detail3}}</p> -->

        </div>
    </div>
</section>